import React from 'react';
import CurrentSubscription from './CurrentSubscription';
import PaymentMethod from './PaymentMethod';
import CreditBalance from './CreditBalance';
import SubscriptionSkeletonLoader from "./SubscriptionSkeletonLoader";
import {useSelector} from "react-redux";

const Subscription = ({ setActiveTab }) => {
    const { loadingBillingData } = useSelector((state)=>(state.billingReducer));

    return (
        <div style={{ marginTop: 16 }}>
            {
                loadingBillingData ?
                    <SubscriptionSkeletonLoader/> :
                    <>
                        <CurrentSubscription />
                        <PaymentMethod />
                        <CreditBalance
                            setActiveTab={setActiveTab}
                        />
                    </>
            }
        </div>
    );
};

export default Subscription;